<template>
  <v-list-tile class="user-row">
    <v-list-tile-content data-tid="user-name">
      <v-list-tile-title v-if="isRegistered">{{
        `${user.firstname} ${user.lastname}`
      }}</v-list-tile-title>
      <v-list-tile-title v-else>{{ user.email }}</v-list-tile-title>
    </v-list-tile-content>
    <v-list-tile-content class="tile-content-share-mail">
      <v-list-tile-sub-title v-if="isRegistered">{{
        user.email
      }}</v-list-tile-sub-title>
      <v-list-tile-sub-title v-else
        >invited {{ timestampAgo(user.updated_at) }}</v-list-tile-sub-title
      >
    </v-list-tile-content>
    <v-list-tile-content
      v-if="isOwner || isCurrentUser"
      class="tile-content-role owner"
    >
      <v-list-tile-title>{{ user.role | capitalize }}</v-list-tile-title>
    </v-list-tile-content>
    <v-select
      v-else
      :items="[
        { value: 'editor', text: 'Editor' },
        { value: 'admin', text: 'Admin' }
      ]"
      :value="user.role"
      solo
      class="tile-content-role"
      @change="$emit('save', { id: user.id, role: $event })"
    />

    <v-list-tile-action
      :class="isOwner || isRegistered ? 'v-list__tile__action_owner' : ''"
    >
      <v-layout>
        <v-flex>
          <v-tooltip v-if="!isCurrentUser && !isRegistered" top>
            <template slot="activator" small>
              <v-btn
                data-tid="resend-user-invitation"
                icon
                class="custom-btn"
                @click="$emit('resendInvitation', user)"
              >
                <v-icon>send</v-icon>
              </v-btn>
            </template>
            <span>Resend Invitation</span>
          </v-tooltip>
        </v-flex>
        <v-flex>
          <v-btn
            :disabled="isOwner || isCurrentUser"
            data-tid="delete-user-modal"
            icon
            class="custom-btn"
            @click="$emit('delete', user)"
          >
            <v-icon>delete</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-list-tile-action>
  </v-list-tile>
</template>

<script>
export default {
  filters: {
    capitalize: function(value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    }
  },
  props: {
    currentUser: {
      type: Object,
      required: true
    },
    user: {
      type: Object,
      required: true
    }
  },
  computed: {
    isCurrentUser() {
      return this.user.id === this.currentUser.id;
    },
    isOwner() {
      return this.user.role === "owner";
    },
    isRegistered() {
      return !!this.user.google_user_id;
    }
  },
  methods: {
    timestampAgo(date) {
      return this.$dayjs(date).fromNow();
    }
  }
};
</script>

<style lang="scss">
.user-row .v-list__tile {
  margin-bottom: 5px;
  align-items: baseline;

  > div:first-child {
    width: 40%;
  }
  .tile-content-share-mail {
    width: 30%;
  }
  .tile-content-role {
    width: 25%;

    .v-list__tile__title {
      padding-left: 12px;
    }
  }
  .v-list__tile__action {
    position: relative;
    min-width: 100px;
    height: auto;

    &.v-list__tile__action_owner {
      top: 6px;
    }

    .layout {
      padding-left: 30px;

      .flex {
        min-width: 50px;

        .v-btn {
          height: 35px;
        }
      }
    }
  }
}
</style>
